module.exports = __webpack_public_path__ + "static/media/success.2eb47a3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/alerts/success.svg
// module id = 307
// module chunks = 0